import { logger } from '../../core/logger';
import { createSkeletonLoader } from './skeleton-loader';

export const createPaymentContainer = (): HTMLDivElement => {
  const container = document.createElement('div');
  container.dataset.eswComponent = 'payment-panel';
  container.style.position = 'relative';

  const mfeWrapper = document.createElement('div');
  mfeWrapper.className = 'payment-panel-content';
  hideMfeWrapper(mfeWrapper);

  container.appendChild(mfeWrapper);
  container.appendChild(createSkeletonLoader());

  return container;
};

export const mountContainer = (selector: string): { mountedComponent: Element | null; container: HTMLDivElement | null } => {
  const mountedComponent = document.querySelector(selector);

  if (!mountedComponent) {
    logger.error(`Component with selector ${selector} not found`);
    return { mountedComponent: null, container: null };
  }

  const container = createPaymentContainer();
  mountedComponent.appendChild(container);

  return {
    mountedComponent,
    container: container.querySelector('.payment-panel-content') as HTMLDivElement
  };
};

export const showMfeWrapper = (mfeWrapper: HTMLElement): void => {
  mfeWrapper.style.visibility = 'visible';
  mfeWrapper.style.position = 'static';
  mfeWrapper.style.width = '';
  mfeWrapper.style.height = 'auto';
  mfeWrapper.style.overflow = '';
};

export const hideMfeWrapper = (mfeWrapper: HTMLElement): void => {
  mfeWrapper.style.visibility = 'hidden';
  mfeWrapper.style.position = 'absolute';
  mfeWrapper.style.width = '100%';
  mfeWrapper.style.height = '1px';
  mfeWrapper.style.overflow = 'hidden';
};

export const unmountContainer = (container: HTMLDivElement | null): void => {
  container?.remove();
};

export const registerWindowListeners = (
  messageHandler: (event: MessageEvent) => void,
  unloadHandler: (event: Event) => void
): { removeListeners: () => void } => {
  window.addEventListener('message', messageHandler, false);
  window.addEventListener('beforeunload', unloadHandler);

  return {
    removeListeners: () => {
      window.removeEventListener('message', messageHandler);
      window.removeEventListener('beforeunload', unloadHandler);
    }
  };
};
